import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import GetCustomer from "./getCustomer";
import GetProfile from "./getProfile";
import GetLatestData from "./getLatestData";
import GetLocalTracker from "./getLocalTracker";
import GetAITrackerData from "./getAITrackerData";
import GetLLMTrackerData from "./getLLMTrackerData";

const MANAGEDATA_CONFIGURE = ({ rankTableApi }) => {
  const dispatch = useDispatch();
  const email = useSelector((state) => state.email);

  useEffect(() => {
    if (!rankTableApi) {
      const timeout = setTimeout(() => {
        dispatch({ type: "NOTLOADING" });
      }, 1000);

      return () => clearTimeout(timeout); // Cleanup timeout
    }
  }, [rankTableApi, dispatch]); // Ensured dependencies are correct

  return (
    <>
      <GetProfile />
      {email && (
        <>
          <GetCustomer />
          {rankTableApi && (
            <>
              <GetLatestData />
              <GetLocalTracker />
              <GetAITrackerData />
              <GetLLMTrackerData />
            </>
          )}
        </>
      )}
    </>
  );
};

export default MANAGEDATA_CONFIGURE;
